require('./mortgageRequestExpensesAmmount.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
// @ components
const MortgageRequestExpensesItemList = require('components/mortgageRequest/mortgageRequestExpenses/mortgageRequestExpensesItemList');

const MortgageRequestExpensesAmmount = props => {
    const { importeHipoteca, valorArras, iva, pendingSale, isNewProperty } = props;

    const expensesItemClasses = {
        item: ['mortgage-request-expenses-ammount__item', 'row', 'no-outside-gutter'],
        title: ['mortgage-request-expenses-ammount__title', 'col-xs-9'],
        value: ['mortgage-request-expenses-ammount__value', 'col-xs-3'],
        list: ['mortgage-request-expenses-ammount', 'list-unstyled'],
    };
    let itemList = [

        {
            text: 'mortgageRequestExpensesAmmount-mortgageRequestExpensesAmmount_mortgage',
            value: importeHipoteca
        },
        {
            text: 'mortgageRequestExpensesAmmount-ammount',
            value: valorArras
        },
        {
            text: 'mortgageRequestExpensesAmmount-mortgageRequestExpensesAmmount_pendingSale',
            value: pendingSale,
            boldLetter: true
        }
    ];

    if (isNewProperty) {
        itemList.unshift({ text: 'mortgageRequestExpensesAmmount-mortgageRequestExpensesAmmount_iva', value: iva });
    }

    return (
        <MortgageRequestExpensesItemList
            expensesItemClasses={expensesItemClasses}
            itemsList={itemList} />
    );
};

MortgageRequestExpensesAmmount.propTypes = {
    importeHipoteca: PropTypes.number.isRequired,
    valorArras: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    currencyFormatted: PropTypes.string.isRequired,
    iva: PropTypes.number.isRequired,
    pendingSale: PropTypes.number.isRequired,
    isNewProperty: PropTypes.bool
};

MortgageRequestExpensesAmmount.defaultProps = {
    importeHipoteca: 0,
    valorArras: 0,
    iva: 0,
    pendingSale: 0
};

module.exports = MortgageRequestExpensesAmmount;
